import React, { Fragment } from 'react';

import { ReactComponent as InfoButtonSvg } from '../../assets/InfoButton.svg';
import { ReactComponent as MessagePointerBorderedSvg } from '../../assets/MessagePointerBordered.svg';
import { BubbleContentContainer, BubblePointerContainer, ContextBubbleContainer } from './styled';

interface IContextBubbleProps {
  text: string;
  postitionLeft?: number;
}

const ContextBubble = (props: IContextBubbleProps) => {
  const [showContext, setShow] = React.useState(false);

  const { postitionLeft = 0 } = props;

  const handleMouseOver = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <ContextBubbleContainer onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
      <InfoButtonSvg />
      {showContext && (
        <Fragment>
          <BubblePointerContainer>
            <MessagePointerBorderedSvg />
          </BubblePointerContainer>
          <BubbleContentContainer postitionLeft={postitionLeft}>
            {props.text}
          </BubbleContentContainer>
        </Fragment>
      )}

    </ContextBubbleContainer>
  );
};

export default ContextBubble;
